import { usePage } from '@inertiajs/vue3'
import { computed } from 'vue'

export type CurrentUserType = {
  avatar: string | null
  id: number
  slug: string
  name: string
  surname: string
  fullName: string
  email: string
  language: {
    id: number
    code: 'en' | 'it'
  }
  twoFactorEnabled: boolean
  passwordConfirmed: boolean
}

type UserRole = 'admin' | 'circular_operators' | 'customers' | 'unknown'

const EMPTY_COMPANY = {
  id: null,
  name: null,
  limitedAccess: false,
}

export const useCurrentUser = () => {
  const page = usePage<{
    auth: null | {
      user: CurrentUserType
      // abilities: string[]
      role: UserRole
      company: {
        id: number
        name: string
        limitedAccess: boolean
      } | null
      lastVisitedPage: string | null
    }
  }>()

  const user = computed(() => {
    if (!page.props.auth?.user) {
      return {
        avatar: null,
        id: null,
        slug: null,
        name: null,
        surname: null,
        fullName: null,
        email: null,
        language: { id: 0, code: 'en' },
        twoFactorEnabled: false,
        passwordConfirmed: false,
        company: EMPTY_COMPANY,
        isCircularOperator: false,
        isCustomer: false,
      }
    }
    return {
      ...page.props.auth.user,
      company: page.props.auth.company ?? EMPTY_COMPANY,
      isCircularOperator: page.props.auth.role === 'circular_operators',
      isCustomer: page.props.auth.role === 'customers',
    }
  })

  const isLoggedIn = computed(() => {
    return page.props.auth !== null
  })

  const lastVisitedPage = computed(() => {
    if (!page.props.auth?.lastVisitedPage) return null
    return page.props.auth.lastVisitedPage
  })

  const role = computed(() => {
    if (!page.props.auth?.role) return 'unknown'
    return page.props.auth.role
  })

  return {
    user,
    isLoggedIn,
    role,
    lastVisitedPage,
  }
}
